import { cn } from '@utils/helpers';
import { useFragment } from 'react-relay';
import { detailFilterFragment } from './DetailFilter.relay';
import { DetailFilterDropdownCategory } from './lib/detailFilterDropdownCategory';
import { DetailFilterListCategory } from './lib/detailFilterListCategory';
import { DetailFilterSelectionInfo } from './lib/detailFilterSelectionInfo';
import type { DetailFilterPropsType } from './types';

const DetailFilterCategoryTypeMap = {
  DetailFilterDropdownCategory,
  DetailFilterListCategory,
};

const detailFilterColIsRadio = ['institutional'];

const DetailFilter: React.FC<DetailFilterPropsType> = (props: DetailFilterPropsType) => {
  const detailFilter = useFragment(detailFilterFragment, props.detailFilter);

  return (
    <div className={cn('grid transition-[grid-template-rows] duration-300 ease-in-out', props.isVisible ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
      <div className="overflow-hidden">
        <div className="w-full pt-5">
          {detailFilter.filtercategory.map((category) => {
            if (!('col' in category)) {
              return null;
            }
            const DetailFilterCategoryType = DetailFilterCategoryTypeMap[category.__typename];

            return (
              <DetailFilterCategoryType
                key={category.col}
                filterHandlerFn={props.filterHandlerFn}
                category={category as any}
                radio={detailFilterColIsRadio.indexOf(category.col) > -1 ? true : props.radio}
                inputGroupName={`Input-${category.col}`}
                filterVals={Reflect.has(props.filterVals, category.col) ? props.filterVals[category.col] : []}
              />
            );
          })}
        </div>
        <DetailFilterSelectionInfo selectionInfo={detailFilter.selectioninfo} filterCount={props.filteredCounter} hasResetOption={props.hasResetOption} resetHandlerFn={props.resetHandlerFn || props.filterHandlerFn} />
      </div>
    </div>
  );
};

export { DetailFilter };
